var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiRrWifiAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11 23a1 1 0 1 1 1 1 1 1 0 0 1 -1-1zm4.535-2.122a1 1 0 0 0 0-1.414 5 5 0 0 0 -7.07 0 1 1 0 0 0 1.414 1.414 3.074 3.074 0 0 1 4.242 0 1 1 0 0 0 1.414 0zm2.829-2.828a1 1 0 0 0 0-1.414 9.01 9.01 0 0 0 -12.728 0 1 1 0 0 0 1.414 1.414 7.011 7.011 0 0 1 9.9 0 1 1 0 0 0 1.414 0zm-12.377 4.111a1 1 0 0 0 -.826-1.148 3.809 3.809 0 0 1 -3.124-2.939 3.473 3.473 0 0 1 1.823-3.594 2 2 0 0 0 .805-2.69 6 6 0 1 1 11.059-4.514 3.1 3.1 0 0 0 2.045 2.052 5.972 5.972 0 0 1 4.212 6.211 5.687 5.687 0 0 1 -3.41 4.725 1 1 0 0 0 .858 1.806 7.638 7.638 0 0 0 4.547-6.376 7.96 7.96 0 0 0 -5.62-8.277 1.089 1.089 0 0 1 -.722-.734 8 8 0 0 0 -15.489.841 7.78 7.78 0 0 0 .778 5.19 5.453 5.453 0 0 0 -2.866 5.641 5.826 5.826 0 0 0 4.782 4.632 1 1 0 0 0 1.148-.826z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrWifiAlt);
export default __webpack_public_path__ + "static/media/fi-rr-wifi-alt.4c1d2328.svg";
export { ForwardRef as ReactComponent };